import api from "@/services/api";
import {
  PLANIFICATIONS_BASE_URL,
  fetchPlanificationTicket,
  planificationBlobFor,
  planificationFetchHeaders,
} from "@/services/planificationApi";

// Each planification call: ask main for a ticket (this is where login + uses
// are enforced), then call the worker server directly with that ticket.
function withTicket(endpoint, fn) {
  return fetchPlanificationTicket(endpoint).then((ticket) => fn(ticket));
}

export default {
  tr(subject, level, oa, type, condition) {
    const params = new URLSearchParams({
      subject: subject,
      level: level,
      type: type,
      oa: JSON.stringify(oa),
      condition: condition,
    }).toString();
    return fetch(`/api/get_data/?${params}`).then((response) => {
      return response.body;
    });
  },
  getDailyPlanification(subject, level, oa, type, ind, condition) {
    const params = new URLSearchParams({
      subject: subject,
      level: level,
      type: type,
      oa: JSON.stringify(oa),
      ind: JSON.stringify(ind),
      condition: condition,
    }).toString();
    return withTicket("daily", (ticket) =>
      fetch(
        `${PLANIFICATIONS_BASE_URL}/get_daily_planification/?${params}`,
        { headers: planificationFetchHeaders(ticket) }
      ).then((response) => response.body)
    );
  },
  getDailyPlanificationStructured(subject, level, oa, type, ind, condition) {
    const params = new URLSearchParams({
      subject: subject,
      level: level,
      type: type,
      oa: JSON.stringify(oa),
      ind: JSON.stringify(ind),
      condition: condition,
    }).toString();
    return withTicket("structured", (ticket) =>
      fetch(
        `${PLANIFICATIONS_BASE_URL}/assisted_materials/get_daily_planification_structured/?${params}`,
        { headers: planificationFetchHeaders(ticket) }
      ).then((response) => response.body)
    );
  },
  getDemoPlanification() {
    return fetch(`${PLANIFICATIONS_BASE_URL}/get_demo_planification/`).then(
      (response) => response.body
    );
  },
  downloadPlanification(payload) {
    return api
      .post("download_planification/", payload, { responseType: "blob" })
      .then((response) => response);
  },
  getPrice(params) {
    return api
      .get("marketplace/product-price/", { params: params })
      .then((response) => response.data);
  },
  // Obtener las condiciones guardadas del usuario
  getConditions() {
    return fetch("/api/get_special_conditions/").then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        return [];
      }
    });
  },
  // Guardar la condicion dada por el usuario
  saveCondition(condition) {
    return api
      .post("create_special_condition/", { condition })
      .then((response) => response.data);
  },
  // Generar PPT de planificacion diaria para descargar
  downloadPptPlanification(payload) {
    return withTicket("ppt", (ticket) =>
      planificationBlobFor(ticket)
        .post("download_ppt_planification/", payload)
        .then((response) => response)
    );
  },
};
